import SectionCollapsible from "./SectionCollapsible";
export default SectionCollapsible;
